import * as React from 'react'

function VmLockOpenIcon({title, titleId, ...props}, svgRef) {
  return React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        fill: 'none',
        viewBox: '0 0 24 24',
        strokeWidth: 1.5,
        stroke: 'currentColor',
        'aria-hidden': 'true',
        ref: svgRef,
        'aria-labelledby': titleId,
      },
      props
    ),
    title
      ? React.createElement(
          'title',
          {
            id: titleId,
          },
          title
        )
      : null,
    React.createElement('path', {
      'aria-label': 'upper',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75',
    }),
    React.createElement('path', {
      'aria-label': 'lower',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z',
    })
  )
}

const ForwardRef = React.forwardRef(VmLockOpenIcon)
export default ForwardRef
